import { network } from 'services/network';
import { useQuery } from 'react-query';
import { IGetDashboard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

const getDashboards = () => {
    return network
        .post('api/bo/getDashboardList')
        .then((response) => {
            return {
                dashboardDetails: response.data.dashboards ? response.data.dashboards : [],
                info: response.data.info,
            };
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryGetDashboards = () => {
    return useQuery<IGetDashboard, QueryError>(['getDashboard'], () => getDashboards());
};
